import { Component, Prop, State, h } from '@stencil/core';
import { schedule } from '../../store/schedule.store';

import { Space } from '@artask/tambr-models/models/spaces.model';


@Component({
  tag: 'tambr-calendar-space-info',
  styleUrl: 'tambr-calendar-space-info.css',
  shadow: true,
})
export class TambrCalendarSpaceInfo {

  @Prop() space: Space;
  @Prop() type: 'card' | 'dialog' = 'card';

  @State() showFullDescription: boolean = false;

  formatPrice( price: number ) {
    return Number.isInteger( price ) ? price.toString() : price.toFixed(2);
  }

  render() {
    return ([
      this.renderCardHeader(),
      this.renderSpaceDescription(),
    ]);
  }


  renderCardHeader() {
    const categoryTitle = schedule.dateSchedule.calendar[ this.space.id ]?.categoryTitle;
    return (
      <div class='space-info-header'>
        <div>
          { categoryTitle ? <div class='space-info-category'>{ categoryTitle }</div> : null }
          <div class='space-info-title'>{ this.space.title }</div>
          { this.renderSpaceFeatures() }
        </div>
        { this.renderSpacePrice() }
      </div>
    )
  }
  

  renderSpacePrice() {
    const priceTypes = {
      15: ' / 15 minutes',
      30: ' / 30 minutes',
      60: ' / hour'
    }
    const priceType = priceTypes[ schedule.dateSchedule.slotDuration ];
    const peakPrice = (this.space.peakPriceEnabled && this.space.peakPrice) ? this.space.peakPrice / 100 : null;
    return (
      <div class='space-info-price'>
        <div class='price'>
          ${ this.formatPrice( this.space.basePrice / 100 ) }
          <span class='price-type'>{ priceType + ( !!peakPrice ? ' (off-peak)' : '' ) }</span>
        </div>
        { peakPrice && <div class='peak-price'>${ this.formatPrice( peakPrice ) + priceType } (peak)</div> }
      </div>
    )
  }


  renderSpaceFeatures() {
    const capacity = this.space.capacity;
    const size = this.space.size;
    const locationTitle = schedule.dateSchedule.calendar[ this.space.id ]?.locationTitle;
    return (
      <div class='space-info-features'>
        { !!capacity && 
          <div class='space-info-features-capacity'> 
            <tambr-icon type='capacity' class='icon'></tambr-icon>
            { capacity }
          </div>
        }
        { !!size && 
          <div class='space-info-features-size'>
            <tambr-icon type='size' class='icon'></tambr-icon>
            { size }
          </div> 
        }
        { locationTitle && 
          <div class='space-info-features-location'>
            <tambr-icon type='location' class='icon'></tambr-icon>
            { locationTitle }
          </div>
        } 
      </div>
    )
  }


  toggleFullDescription() {
    this.showFullDescription = !this.showFullDescription;
  }


  renderSpaceDescription() {
    const text = this.space.description;
    const isLongText = text?.length > 300;

    return (
      <div class='space-info-description'>
        { text && this.showFullDescription ? text : text?.slice(0, 300) }
        { isLongText && !this.showFullDescription && (<span >...</span>) }
        { <span class='space-info-description-spacer'></span>}
        { isLongText && <button class='space-info-description-show-button' onClick={ () => this.toggleFullDescription() }>
        { this.showFullDescription ? 'hide' : 'show more' }</button> }
      </div>
    )
  }

}
